import { defineStore } from "pinia";
import { ref } from "vue";

import { asReadonly } from "@/utils/vue";

export const useCompanySettingsStore = defineStore("companySettings", () => {
  const autoLogoutAfter = ref(0);

  return {
    autoLogoutAfter: asReadonly(autoLogoutAfter),
    setAutoLogoutAfter: (value: number) => (autoLogoutAfter.value = value),
  };
});
